import { useRef } from "react";
import type { MapViewHandle } from "./map-view-imperative-handle";

export function useMapViewHandle() {
	/** Ref */
	const ref = useRef<MapViewHandle>(null);

	/** Return */
	return ref;
}
